<template>
    <div class="dataStatistics mam-master border-radius5 white mar-bot10">
        <el-row class="first-row">
            <el-col :lg="5" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('Total_personal_income')}}</div>
                <div
                        class="data color-span"
                        :class="{on: !isIncludeMinus(dataStatistics.statProfit)}"
                >{{dataStatistics.statProfit}} {{dataStatistics.currency}}</div>
            </el-col>
            <el-col :lg="5" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('rate_of_return')}}</div>
                <div
                        class="data color-span"
                        :class="{on: ! isIncludeMinus(dataStatistics.earningRate)}"
                >{{dataStatistics.earningRate}}</div>
            </el-col>
            <el-col :lg="5" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('Average_billing_cycle')}}</div>
                <div
                        class="data"

                >{{dataStatistics.averageDays}}{{$t('day')}}</div>
            </el-col>
            <el-col :lg="5" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('threeMonthsReturn')}}</div>
                <div
                        class="data"
                >{{dataStatistics.maxRetracement}}</div>
            </el-col>
            <el-col :lg="4" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('contractDetailed.tradingHour')}}</div>
                <div class="data">{{timeComputed}}</div>
            </el-col>
            <el-col :lg="5" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('Total_Management_Revenue')}}</div>
                <div class="data color-span"
                     :class="{on: !isIncludeMinus(dataStatistics.managementProfit)}"
                >{{dataStatistics.managementProfit}} {{dataStatistics.currency}}</div>
            </el-col>
            <el-col :lg="5" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('Average_management_rate_of_return')}}</div>
                <div class="data color-span"
                     :class="{on: !isIncludeMinus(dataStatistics.averageRate)}"
                >{{dataStatistics.averageRate}}</div>
            </el-col>
            <el-col :lg="5" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('Accumulated_funds_under_management')}}</div>
                <div class="data">{{dataStatistics.managementAmount}} {{dataStatistics.currency}}</div>
            </el-col>
            <el-col :lg="5" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('Number_of_trading_periods')}}</div>
                <div class="data">{{dataStatistics.cycleNumber}}</div>
            </el-col>
            <el-col :lg="4" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('Cumulative_number_of_managed_accounts')}}</div>
                <div class="data">{{dataStatistics.managementLoginNumber}}</div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import {isIncludeMinus, matchTime} from '@/utils/common'
  export default {
    name: 'dataStatisticsMamMaster',
    props: {
      dataStatistics: {
        type: Object,
        default() {
          return {
            statProfit: '',
            earningRate: '',
            averageDays: '',
            maxRetracement: '',
            times: '',
            managementProfit: '',
            averageRate: '',
            managementAmount: '',
            cycleNumber: '',
            managementLoginNumber: '',
          }
        }
      }
    },
    computed:{
      timeComputed(){
        return matchTime(this.dataStatistics.times,this);
      }
    },
    methods: {
      matchTime,
      isIncludeMinus
    }
  };
</script>

<style lang="scss" scoped>
    @import "../../../../../../assets/scss/variable";
.dataStatistics {
    .text {
        font-size: 14px;
        color: #999999;
        margin-bottom: 10px;
    }
    .data {
        font-size: 20px;
        color: $themefontcolor;
        font-weight: bold;

    }
    .color-span {
        color: $themeColor;
        &.on {
            color: $themeGreen;
        }
    }
}
</style>
